var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 80,
    viewBox: "0 0 77 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_596_205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.63988 39.6357C1.63808 46.2732 3.3417 52.7543 6.58112 58.4668L1.33008 77.9847L20.9506 72.7474C26.3775 75.7549 32.4578 77.3308 38.6366 77.3313H38.6528C59.0503 77.3313 75.6543 60.4341 75.663 39.6654C75.667 29.6015 71.8206 20.138 64.8322 13.0182C57.8451 5.89902 48.5524 1.97627 38.6513 1.97168C18.2514 1.97168 1.64861 18.8679 1.64018 39.6357",
    fill: "url(#paint0_linear_596_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.318418 39.6234C0.316313 46.4997 2.081 53.2126 5.43591 59.1296L-0.00341797 79.3472L20.3207 73.9222C25.9206 77.0305 32.2256 78.6693 38.6413 78.6717H38.6578C59.7871 78.6717 76.9876 61.1668 76.9966 39.6546C77.0002 29.2291 73.0154 19.4254 65.7774 12.0505C58.5385 4.67659 48.9135 0.612685 38.6578 0.608398C17.5249 0.608398 0.32684 18.1109 0.318418 39.6234ZM12.4222 58.1106L11.6633 56.8843C8.4732 51.7205 6.78943 45.7532 6.79183 39.6258C6.79845 21.7452 21.0928 7.19786 38.6698 7.19786C47.1819 7.20153 55.1815 10.5795 61.1983 16.7085C67.2149 22.838 70.5256 30.986 70.5235 39.6522C70.5156 57.5328 56.221 72.082 38.6578 72.082H38.6452C32.9264 72.0789 27.3177 70.5154 22.4264 67.5609L21.2624 66.8582L9.20169 70.0773L12.4222 58.1106Z",
    fill: "url(#paint1_linear_596_205)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0755 23.3127C28.3578 21.6889 27.6025 21.6561 26.9201 21.6277C26.3612 21.6032 25.7224 21.605 25.0841 21.605C24.4452 21.605 23.4072 21.8497 22.5299 22.8249C21.6516 23.8011 19.1768 26.1601 19.1768 30.9579C19.1768 35.7558 22.6096 40.3929 23.0881 41.0442C23.5673 41.6943 29.7152 51.8553 39.4521 55.7642C47.5443 59.0127 49.1911 58.3666 50.9474 58.2038C52.7039 58.0415 56.6153 55.8454 57.4133 53.5682C58.2118 51.2913 58.2119 49.3395 57.9724 48.9317C57.733 48.5253 57.0941 48.2813 56.1362 47.7938C55.1782 47.3063 50.4682 44.9468 49.5903 44.6213C48.712 44.2961 48.0734 44.1338 47.4346 45.1103C46.7957 46.0852 44.9612 48.2813 44.4021 48.9317C43.8435 49.5836 43.2844 49.6647 42.3267 49.1769C41.3681 48.6876 38.283 47.6591 34.6228 44.3371C31.775 41.7522 29.8524 38.56 29.2935 37.5835C28.7347 36.6086 29.2337 36.0801 29.714 35.5941C30.1444 35.1572 30.6723 34.4554 31.1518 33.8861C31.6294 33.3166 31.7888 32.9103 32.1082 32.2599C32.428 31.6089 32.268 31.0394 32.0288 30.5516C31.7888 30.0638 29.9273 25.2408 29.0755 23.3127Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_596_205",
    x1: 3717.98,
    y1: 7603.27,
    x2: 3717.98,
    y2: 1.97168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_596_205",
    x1: 3850,
    y1: 7874.49,
    x2: 3850,
    y2: 0.608398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_596_205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77,
    height: 79,
    fill: "white",
    transform: "translate(-0.00341797 0.608398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsAppIcon);
export default __webpack_public_path__ + "static/media/WhatsAppIcon.25ba70a77225ef4b4d4d473495398c9f.svg";
export { ForwardRef as ReactComponent };